import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { SystemSection } from '../components/SystemSection';
import { BonusSection } from '../components/BonusSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-284">
      <HeroSection data-id="element-285" />
      <ForWhoSection data-id="element-286" />
      <PainSection data-id="element-287" />
      <BenefitsSection data-id="element-288" />
      <ProtocolSection data-id="element-289" />
      <TestimonialsSection data-id="element-290" />
      <SystemSection data-id="element-291" />
      <BonusSection data-id="element-292" />
      <OfferSection data-id="element-293" />
      <AboutSection data-id="element-294" />
      <FAQSection data-id="element-295" />
      <FinalCTASection data-id="element-296" />
    </main>;
}